/**
 * Registry: import each test from its own file.
 * Add new tests by creating a file and appending it to supportValidatorModules below.
 *
 * Runtime: runValidators() wraps each test in try/catch so a thrown error in one
 * test does not break the others. Keep complex logic isolated per file.
 */
import patientNotDeleted from "./patientNotDeleted";
import patientTimeSpentPresent from "./patientTimeSpentPresent";
// import ehrUploadStatus from "./ehrUploadStatus"; // disabled for now
import clinicalNotePresent from "./clinicalNotePresent";
import chartHistoryPresent from "./chartHistoryPresent";
import dotPhrasesPresent from "./dotPhrasesPresent";
import eAndMPresent from "./eAndMPresent";
import patientSummaryPresent from "./patientSummaryPresent";
import icd10CodesV2Present from "./icd10CodesV2Present";
import transcriptionJobs from "./transcriptionJobs";
import summarizationJobs from "./summarizationJobs";
import { traceValidators } from "./trace";

const supportValidatorModules = [
  transcriptionJobs,
  summarizationJobs,
  clinicalNotePresent,
  patientNotDeleted,
  patientTimeSpentPresent,
  // ehrUploadStatus, // disabled for now
  icd10CodesV2Present,
  dotPhrasesPresent,
  eAndMPresent,
  patientSummaryPresent,
  chartHistoryPresent,
  ...traceValidators,
];

/** @type {import('../types').ValidationTestDefinition[]} */
export const supportValidators = supportValidatorModules.filter(
  (test) => test && typeof test.run === "function"
);
